import { render, staticRenderFns } from "./TabLanguages.vue?vue&type=template&id=890f150a&scoped=true&"
import script from "./TabLanguages.vue?vue&type=script&lang=js&"
export * from "./TabLanguages.vue?vue&type=script&lang=js&"
import style0 from "./TabLanguages.vue?vue&type=style&index=0&id=890f150a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890f150a",
  null
  
)

export default component.exports